<p-dialog [header]="notice()?.header" [visible]="visible()" (visibleChange)="onVisibleChange($event)" [modal]="true"
    [closable]="true" [breakpoints]="{ '5550px': '40vw','575px': '90vw' }" styleClass="border-round-3xl">
    @if (notice(); as notice) {
    <div class="flex flex-column gap-3">
        <div [innerHTML]="notice.messageHtml"></div>
        @if (notice.note) {
        <p class="text-sm text-700 m-0">{{ notice.note }}</p>
        }
        <div class="flex justify-content-end">
            <p-button label="OKAY" styleClass="p-button-raised" [rounded]="true" (onClick)="close()" />
        </div>
    </div>
    }
</p-dialog>
